class Header extends HTMLElement {
  constructor() {
    super();

    this.menuDrawer = document.getElementById('MenuDrawer');
    this.menuDrawerToggle = this.querySelector('[name="menu-drawer-toggle"]');
    this.isMenuDrawerOpen = false;
    this.searchModal = document.getElementById('SearchModal');
    this.searchModalToggles = this.querySelectorAll('[name="search-modal-toggle"]');
    this.searchModalClose = document.querySelector('[name="search-modal-close"]');
    this.isSearchModalOpen = false;

    if (navigator.platform === 'iPhone') {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    this.menuDrawerToggle.addEventListener('click', () => {
      if (this.isMenuDrawerOpen) return this.closeMenuDrawer();

      this.openMenuDrawer();
    });

    this.searchModalToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        this.isSearchModalOpen = !this.isSearchModalOpen;

        if (!this.isSearchModalOpen) return this.closeSearchModal();

        this.openSearchModal();
      });
    });

    this.searchModalClose.addEventListener('click', () => {
      this.closeSearchModal();
    })
  }

  openMenuDrawer() {
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.getBoundingClientRect().bottom)}px`
    );

    trapFocus(this.menuDrawer, this.menuDrawerToggle);
    document.body.classList.add('menu-drawer-open');
    this.isMenuDrawerOpen = true;

    if (!this.isSearchModalOpen) return;

    this.closeSearchModal();
  }

  closeMenuDrawer() {
    document.body.classList.remove('menu-drawer-open');
    removeTrapFocus();
    this.isMenuDrawerOpen = false;
  }

  openSearchModal() {
    trapFocus(this.searchModal, this.searchModalToggle);
    document.body.classList.add('search-modal-open');
    this.isSearchModalOpen = true;
    this.closeMenuDrawer();
  }

  closeSearchModal() {
    document.body.classList.remove('search-modal-open');
    removeTrapFocus();
    this.isSearchModalOpen = false;
  }
}

customElements.define('site-header', Header);
